module.exports = __webpack_public_path__ + "static/media/prawnCurry.1b48401f.jpg";